namespace advisorop.components.advisor {

    export class InvPerformanceGridPtpController {
        performanceDetails: Array<any>;
        public investor: domains.IInvestor;
        rtgId: number;
        showNeto: boolean = true;
        hideSleeves: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;

        // instance of performance grid
        dgPerformanceGridPtp: DevExpress.ui.dxDataGrid;

        constructor(private investorService: services.InvestorService) {

            this.dg = {
                export: {
                    enabled: false,
                    fileName: "PerformanceDetails"
                },
                bindingOptions: {
                    dataSource: "vm.performanceDetails"
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    //pageSize: 5,
                    enabled: false
                },
                rowAlternationEnabled: false,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgPerformanceGridPtp = e.component;
                },
                wordWrapEnabled: true,

                columns: [

                    { dataField: "groupDescription", caption: "", width: 500 },
                    { dataField: "ptpAnnValue", caption: "Performance (Annualized)", format: { type: "percent", precision: 2 }, alignment: 'right' },
                    { dataField: "ptpValue", caption: "Performance (Cumulative)", format: { type: "percent", precision: 2 }, alignment: 'right' },
                ],
                masterDetail: {
                    enabled: true,
                    template: "detail",
                    autoExpandAll: true
                }
            };

        }

        onc3 = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                //console.log('yyyyyyy: ', e);
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        getShowSleeves(): void {
            if (this.investor != undefined) {
                let showSleevesOption = this.investor.loginOptions.filter(o => o.type == domains.LovType.INVESTOR_LOGIN_OPTION_TYPE && o.option == domains.InvestorLoginOption.SHOW_SLEEVES);
                if (showSleevesOption.length > 0) {
                    if (this.hideSleeves != (showSleevesOption[0].value == 0)) {
                        this.hideSleeves = showSleevesOption[0].value == 0;
                    }
                }
            }
        }

        $onInit(): void {
        }

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "performanceDetails" && this.performanceDetails) {
                    //console.log("Performance details data: ");
                    //console.log(this.performanceDetails);
                }
                if (key === "investor") {
                    this.getShowSleeves();
                }
            }
        };

    }



    class InvPerformanceGridPtp implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;


        constructor() {
            this.bindings = {
                performanceDetails: "<",
                investor: "<"
            };
            this.controller = ["investorService", InvPerformanceGridPtpController];
            this.controllerAs = "vm";
            this.templateUrl = "spa/investor-module/components/inv-performance-grid-ptp.html";
        }
    }
    angular.module(Constants.APP).component("invPerformanceGridPtp", new InvPerformanceGridPtp());

}